import styled from 'styled-components';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: rgba(242, 241, 248, 0.5);
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
  color: #56515b;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 40px 40px 32px 40px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 16px 16px 16px;
    gap: 16px;
  }
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: stretch;
  padding: 0 0 0 40px;
  flex: 1;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 0 16px 16px 16px;
  }
`;

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 40px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  font-size: 13px;
  color: #000000;
  margin-top: auto;
`;

export const FooterText = styled.span`
  font-size: 13px;
  color: #000000;
`;

export const LeftPane = styled.div`
  flex: 0 0 42%;
  max-width: 520px;
  min-width: 380px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  background: transparent;

  @media (max-width: 1024px) {
    flex: none;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 24px 0 16px 0;
  }
`;

export const HeaderContent = styled.div`
  flex: 1;
  min-width: 0;
  padding-left: 48px;

  @media (max-width: 1024px) {
    padding-left: 0;
  }
`;

export const Title = styled.h1`
  margin: 0 0 6px;
  font-size: 32px;
  line-height: 40px;
  font-weight: 600;
  color: #000000;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #56515b;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const HeaderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 20px;
  border: none;
  background: #7200e0;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const IconInButton = styled.img`
  display: block;
  width: 14px;
  height: 14px;
`;

export const Icon16 = styled.img`
  display: block;
  width: 16px;
  height: 16px;
`;

export const IconChevronDown = styled.img`
  display: block;
  width: 10px;
  height: 10px;
`;

export const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const StepItem = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
  background: #ad6bed;
  color: #fff;
`;

export const StepContent = styled.div`
  flex: 1;
  padding-top: 8px;
  min-width: 0;
`;

export const StepHeading = styled.div`
  font-size: 20px;
  font-weight: 400;
  color: #1e252a;
  margin-bottom: 6px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const StepDescription = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: #56515b;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
  strong {
    font-weight: 500;
    color: inherit;
  }
`;

export const InlineStepButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  margin: 0 4px;
  border-radius: 20px;
  border: none;
  background: ${(props) => (props.$disabled ? '#b2aeb7' : '#7200e0')};
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
  white-space: nowrap;
  vertical-align: middle;
  flex-shrink: 0;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};
`;

export const StepButton = styled.button`
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 20px;
  border: none;
  background: #7200e0;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const StepButtonIcon = styled.img`
  display: block;
  width: 12px;
  height: 12px;
`;

export const SubjectTaskTypeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;

  div {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }

  > span {
    color: #d1d5db;
    font-size: 14px;
  }
`;

export const STTitle = styled.h3`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(123, 115, 130, 1);
`;

export const STDetails = styled.h3`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(86, 81, 91, 1);
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UpdateButton = styled.button`
  display: flex;
  gap: 3px;
  background-color: transparent;
  border: none;
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  font-size: var(--font-size-s);
  line-height: 20px;
  color: #8a2be5;
  cursor: pointer;
`;

export const StyledBox = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 20px;
`;

export const StyledMainTabList = styled(TabList)`
  width: 100%;
  padding: 0px 20px !important;
`;

export const StyledTab = styled(Tab)`
  text-transform: none !important;
  font-family: IBM Plex Sans !important;
`;

export const TabText = styled.div`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: ${(props) => (props.active ? '#7200e0' : '#918B97')};
`;

export const HandwrittenTabsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-height: 0;
`;

export const HandwrittenStepsBox = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 20px;
`;

export const HandwrittenStepTabList = styled(TabList)`
  width: 100%;
  display: flex !important;
  flex-direction: row !important;

  .MuiTabs-flexContainer {
    justify-content: center;
    align-items: center;
  }
`;

export const HandwrittenStepTab = styled(Tab)`
  text-transform: none !important;
  font-family: IBM Plex Sans !important;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
  opacity: ${(props) => (props.isDisabled ? 0.4 : 1)};
`;

export const HandwrittenStepPanel = styled(TabPanel)`
  width: 100% !important;
  padding: 0 !important;
  display: flex !important;
  flex: 1 1 auto;
  min-height: 0;
`;

export const HandwrittenTabPart = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const HandwrittenTabNumber = styled.div`
  width: 20px;
  height: 20px;
`;

export const HandwrittenTabNumberText = styled.div`
  font-family: IBM Plex Sans;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.52px;
  text-align: center;
  background: ${(props) => (props.active ? '#7200e0' : '#ffffff')};
  color: ${(props) => (props.active ? '#ffffff' : '#918b97')};
  border: ${(props) =>
    props.active ? '1.5px solid #7200e0' : '1.5px solid #918b97'};
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HandwrittenStepText = styled.div`
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: ${(props) => (props.active ? '#7200e0' : '#918b97')};
`;

export const HandwrittenUploadFilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 220px;
  background: var(--color-neutral-white, #f1e6fc);
  gap: 12px;
`;

export const HandwrittenUploadFilesText = styled.div`
  font-family: IBM Plex Sans;
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  text-align: center;
  color: #918b97;
  width: 280px;
`;

export const RightPane = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 32px 0 0 0;
  background: transparent;

  @media (max-width: 1024px) {
    padding: 0 0 16px 0;
  }
`;

export const QuestionSection = styled.div`
  background: #ffffff;
  border-radius: 8px 0 0 8px;
  border: 1px solid rgba(201, 198, 204, 0.5);
  border-right: none;
  overflow: hidden;

  @media (max-width: 1024px) {
    border-radius: 8px;
    border-right: 1px solid rgba(201, 198, 204, 0.5);
  }
`;

export const SectionLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #00000096;
  background-color: #f1e6fc;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(201, 198, 204, 0.5);
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const QuestionInput = styled.div`
  min-height: 90px;
  padding: 30px 0 0 60px;
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  line-height: 20px;
  color: #56515b;
  opacity: 0.6;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const GenerateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px 16px 16px;
  background: #fff;
  border-top: 1px solid #C9C6CC80;
`;

export const ChevronButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  color: #b0b5c3;
  flex-shrink: 0;
`;

export const GenerateInput = styled.input`
  flex: 1;
  border: 1px solid #B2AEB7;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #B2AEB7;
  background: #fff;
  outline: none;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);

  &::placeholder {
    color: #B2AEB7;
  }
`;

export const GenerateButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #b2aeb7;
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: #4b464f !important;
  -webkit-text-fill-color: #4b464f;
  cursor: default;
  white-space: nowrap;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const SparkleIconWrap = styled.span`
  display: flex;
  align-items: center;
  color: #7200e0;
`;

export const ResponseSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 8px 0 0 0;
  border: 1px solid rgba(201, 198, 204, 0.5);
  border-right: none;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
  min-height: 360px;

  @media (max-width: 1024px) {
    border-radius: 8px;
    border-right: 1px solid rgba(201, 198, 204, 0.5);
    min-height: 260px;
  }
`;

export const ResponseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background-color: #f1e6fc;
  border-bottom: 1px solid rgba(201, 198, 204, 0.5);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const ResponseLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #00000096;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const SubmitButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 20px;
  border: none;
  background: #b2aeb7;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: default;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const SubmitButtonIcon = styled.img`
  display: block;
  width: 20px;
  height: 20px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 20px;
  border-top: 1px solid #f0e7ff;
  border-bottom: 1px solid #f0e7ff;
`;

export const ToolbarButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #56515b;
  border-radius: 4px;
  font-size: 14px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const ToolbarSelect = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border: 1px solid #dec6ff;
  border-radius: 6px;
  font-size: 13px;
  color: #56515b;
  background: #fff;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const ToolbarDivider = styled.div`
  width: 1px;
  height: 20px;
  background: #dec6ff;
  margin: 0 8px;
`;

export const ResponseBody = styled.div`
  flex: 1;
  padding: 30px 0 0 60px;
  font-size: 16px;
  line-height: 22px;
  color: #56515b;
  opacity: 0.6;
  min-height: 150px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const HandwrittenBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #ffffff;
  min-height: 0;
`;

export const ZoomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
`;

export const ZoomLabel = styled.span`
  font-size: 13px;
  color: #56515b;
  opacity: 0.6;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const ZoomSlider = styled.div`
  position: relative;
  width: 100px;
  height: 4px;
  background: #dec6ff;
  border-radius: 2px;
`;

export const ZoomSliderThumb = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  background: rgba(114, 0, 224, 0.5);
  border-radius: 50%;
`;

export const ZoomValue = styled.span`
  font-size: 13px;
  color: #56515b;
  opacity: 0.6;
  min-width: 36px;
  text-align: right;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', Helvetica);
`;

export const ToolbarUnderline = styled.span`
  text-decoration: underline;
`;

export const ToolbarStrikethrough = styled.span`
  text-decoration: line-through;
`;
